import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import Grid from 'components/core/Grid';
import LookupTableInput from 'components/LookupTableInput';
import Input from 'components/core/Input';
import Button from 'components/core/Button';
import Stack from 'components/core/Stack';

const NoteAdd = ({ 
    notes,
    options,
    onNoteChange, 
    onAddNote,
    onRemoveNote,
    parentForm
}) => {

    const filteredOptions = options.noteTypes.filter(option => {
        return option.get('filteredFor') === parentForm
    })
    
    return (
        <>
            {notes.map((note, index) => (
                <Grid container spacing={2} key={index}>
                    <Grid item xs={12} md={4}>
                        <LookupTableInput
                            id="noteType"
                            label="Note Type"
                            value={note.type}
                            onChange={(value) => onNoteChange(index, 'type', value)}
                            options={filteredOptions}
                            getOptionLabel={(option) => option?.get('label')}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Input
                            label="Note Text"
                            type="textarea"
                            value={note.text}
                            onChange={(value) => onNoteChange(index, 'text', value)}
                        />
                    </Grid>
                    {onRemoveNote && notes.length > 0 && !note.isDefault && (
                        <Grid item xs={12} md={2}>
                            <Button 
                                variant="outlined"
                                color="danger"
                                onClick={() => onRemoveNote(index)}
                                sx={{ mt: 3.5 }}
                            >
                                Remove
                            </Button>
                        </Grid>
                    )}
                </Grid>
            ))}
            <Button 
                onClick={onAddNote}
                sx={{ mt: 2 }}
            >
                {notes.length > 0 ? 'Add Another Note' : 'Add Note'}
            </Button>
        </>
    );
};

export default NoteAdd;